module.exports = __webpack_public_path__ + "static/Jost-Regular-3111ed95b86ca169c8b12ccf1c3f3ec2.woff";